export default "__VITE_ASSET__CIft_Lx3__"